import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { Grid, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useCallback } from "react";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import {
  FieldConfigurationType,
  IrrCashFlowFrequency,
} from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureField } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  measure: MeasureField;
  onClose: () => void;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function CashFlowFrequencyMenuItem({ measure, saveChanges, onClose, readonly }: Props) {
  if (measure.config.type === FieldConfigurationType.Irr) {
    return (
      <CashFlowFrequency
        frequency={measure.config.cashFlowFrequency || IrrCashFlowFrequency.Daily}
        saveChanges={saveChanges}
        onClose={onClose}
        readonly={readonly}
      />
    );
  }
  return null;
}

function CashFlowFrequency({
  frequency,
  saveChanges,
  onClose,
  readonly,
}: Pick<Props, "saveChanges" | "onClose"> & { frequency: IrrCashFlowFrequency; readonly: boolean }) {
  const handleChange = useCallback(
    (_: React.MouseEvent<HTMLElement>, newValue: IrrCashFlowFrequency | null) => {
      if (frequency === newValue || newValue === null) {
        onClose();
      } else {
        saveChanges({ cashFlowFrequency: newValue }, false);
      }
    },
    [frequency, onClose, saveChanges]
  );

  return (
    <Grid container sx={{ alignItems: "center", flexWrap: "nowrap", width: "100%" }}>
      <Typography noWrap>Cash Flow Frequency</Typography>
      <HorizontalFill />
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={frequency}
        fullWidth
        sx={{ width: 208 }}
        onChange={handleChange}
        disabled={readonly}
      >
        <ToggleButton value={IrrCashFlowFrequency.Daily} sx={{ py: 0.3, fontWeight: 400 }}>
          {IrrCashFlowFrequency.Daily}
        </ToggleButton>
        <ToggleButton value={IrrCashFlowFrequency.Monthly} sx={{ py: 0.3, fontWeight: 400 }}>
          {IrrCashFlowFrequency.Monthly}
        </ToggleButton>
        <ToggleButton value={IrrCashFlowFrequency.Quarterly} sx={{ py: 0.3, fontWeight: 400 }}>
          {IrrCashFlowFrequency.Quarterly}
        </ToggleButton>
      </ToggleButtonGroup>
    </Grid>
  );
}
